// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__4OJ31","header":"ClearentDisclaimer_header__16mPo","inner":"ClearentDisclaimer_inner__19eUM"};